import React, {useEffect} from "react";
import './AnalizaMain.css';
import MathJax from 'react-mathjax-preview';
import {Link, useHistory} from "react-router-dom";
import * as BiIcons from "react-icons/bi";
import TeX from '@matejmazur/react-katex';

export default function FunkcjeJednejZmiennej(){

	useEffect(()=>{
		document.title="Funkcje jednej zmiennej";
	},[])

	const { push } = useHistory();

	const comeBackFunc=()=>{
		push('/analiza');
	}

	return(
		<div className='conceptsContainer'>
			<div className='comeBackDiv' onClick={comeBackFunc}>
				<BiIcons.BiArrowBack/>
				<div style={{textAlign: 'left', alignItems: 'left'}}>Cofnij</div>
			</div>

			<h1>Funkcja jednej zmiennej</h1>
			<p>Możemy powiedzieć, że w zbiorze X jest określona pewna funckja <TeX math={'f'}/>(tj. funkcja jednej zmiennej), jeżeli dla każdej liczby
				<TeX math={'x'}/> ze zbioru X jest przyporządkowana dokładnie jedna liczba <TeX math={'y'}/> ze zbioru Y. Zapisujemy to:</p>
			<p><TeX math={'y=f(x)'}/>, gdzie <TeX math={'x'}/> - argument funkcji / zmienna niezależna, <TeX math={'y'}/> - zmienna zależna.</p>
			<p>Dziedzina funkcji <TeX math={'f'}/> - to zbiór X wartości argumentów funkcji <TeX math={'f'}/>.</p>
			<p>Zakres funkcji <TeX math={'f'}/> - to zbiór Y wartości funkcji f.</p>
			<p>Dla wyjaśnienia:</p>
			<p className='oneLine centerVertical'>Zakresem funkcji <TeX math={'y=x^2-4'}/> &nbsp;jest zbiór liczb &nbsp;<TeX math={'y'}/>&nbsp;
				spełniających nierówność:<MathJax math={'`-&#8734;&#60;x&#60;+&#8734;`'}/>.</p>
			<p className='oneLine centerVertical'>Zakresem funkcji <MathJax math={'`sqrt(16-x^2)`'}/>&nbsp; jest zbiór liczb <TeX math={'y'}/>
			spełniających nierówność: -2&#8804;x&#8805;2.</p>

			<br/><br/>

			<h2>Funkcja złożona</h2>
			<p>Funkcja <TeX math={'y=f(g(x))'}/> jest przykładem funkcji złożonej.</p>
			<p>Jeżeli polem funkcji <TeX math={'g(x)'}/> jest zbiór liczb A, a zakresem zbiór liczb B. Polem funkcji <TeX math={'f(z)'}/>
				jest zbiór liczb C,a zakresem zbiór liczb D, i B jest zawarte w C</p>
			<p>to oba zbiory przyporzodkowują każdej liczbie <TeX math={'x'}/> ze zbioru A dokładnie jedną liczbą D.</p>

			<br/><br/>

			<h2>Funkcja różnowartościowa</h2>
			<p>Jest to funkcja, w której nie ma dwóch takich liczb, dla których wartość funkcji wynosi tyle samo.</p>
			<p>Funkcją różnowartościową może być funkcja liniowa, która cały czas maleje lub rośnie.</p>

			<br/><br/>

			<h2>Funkcja odwrotna</h2>
			<p>Jest to funkcja, w której argument z jednej funkcji jest wartością dla drugiej, dla wyjaśnienia:</p>
			<p><TeX math={'y=f(x)'}/> &#8743; <TeX math={'x=g(y)'}/></p>


			<br/><br/>

			<Link to="/analiza/pojecia-wstepne/symetria-prosta"><button>Symetria punktów i osi względem prostej</button></Link>

		</div>
	);
}